

export const ServiceClassificationRouting = [
  {
    path: "/maintenanceSetting/serviceClassification",
    name: "maintenanceSetting-serviceClassification-list",
    meta: { title: "服务分类" },
    component: () =>
      import(
        /* webpackChunkName: "basic-accessManagement-brand" */ "@/views/maintenance/serviceClassification/list/index.vue"
      ),
  },
];
